'use client';

import { createTheme, styled } from "@mui/material/styles";

const sharedComponents = {
    MuiButton: { styleOverrides: { root: { fontSize: '1rem' } } },
    MuiAvatar: {
        styleOverrides: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            root: ({ theme: t }: any) => ({ margin: t.spacing(1), backgroundColor: t.palette.secondary.main }),
        },
    },
    MuiFormControl: { styleOverrides: { root: () => ({ margin: 0, minWidth: 60 }) } },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MuiToolbar: { styleOverrides: { root: ({ theme: t }: any) => ({ padding: t.spacing(2), margin: t.spacing(0) }) } },
    MuiDialog: {
        styleOverrides: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            root: ({ theme: t }: any) => ({
                '& .MuiDialog-paper': { borderRadius: 10, border: '1px solid', padding: t.spacing(2) },
            }),
        },
    },
    MuiDialogTitle: { styleOverrides: { root: () => ({ fontWeight: 400, fontSize: '2rem' }) } },
    MuiLinearProgress: {
        styleOverrides: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            root: ({ theme: t }: any) => ({
                borderRadius: 2, border: '1px solid', padding: t.spacing(1),
                '& .MuiLinearProgress-barColorPrimary': {
                    background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(255,255,255,1) 0%, rgba(215,255,215,1) 50%, rgb(104, 172, 81) 100%)',
                },
            }),
        },
    },
    MuiTableCell: {
        styleOverrides: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            root: ({ theme: t }: any) => ({
                borderBottom: '1px solid', borderColor: t.palette.divider,
                padding: t.spacing(0, 2), fontSize: '1rem', fontWeight: 400, lineHeight: 'auto',
            }),
        },
    },
};

export const lightTheme = createTheme({
    // palette: {
    //     mode: 'light',
    //     primary: {
    //         main: '#3f51b5',
    //     },
    //     secondary: {
    //         main: '#f50057',
    //     },

    // },
    palette: {
        mode: 'light',
        primary: {
            light: '#105577',
            main: '#156082',
            dark: '#68ac51',
            contrastText: '#fff',
        },
        secondary: {
            light: '#5efc82',
            main: '#00c853',
            dark: '#009624',
            contrastText: '#000',
        },
        // gradient: {
        //     main: "linear-gradient(-39deg, #4991f8 0%, #4bc1ff 100%)",
        //     mainChannel: "0 0 0",
        //     light: "linear-gradient(135deg, #4aaffd 0%, #4992f8 100%)",
        //     lightChannel: "0 0 0",
        //     dark: "linear-gradient(135deg, #4cc2ff 0%, #4aa0fa 100%)",
        //     darkChannel: "0 0 0",
        //     contrastText: "#fff",
        //     contrastTextChannel: "0 0 0"
        // }
    },
    components: sharedComponents,
});

export const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            light: '#4da6c8',
            main: '#5bb8d4',
            dark: '#68ac51',
            contrastText: '#fff',
        },
        secondary: {
            light: '#5efc82',
            main: '#00c853',
            dark: '#009624',
            contrastText: '#000',
        },
        background: {
            default: '#121212',
            paper: '#1e1e1e',
        },
    },
    components: sharedComponents,
});

// Backward-compatible alias
export const theme = lightTheme;

export const MyPaper = styled("div")({
    marginTop: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
});

//         MuiForm: {
//             styleVOerrides: {
//                 width: "100%", // Fix IE 11 issue.
//                 marginTop: theme.spacing(1),
//             }
//         },
//     vote: {
//         margin: theme.spacing(1, 0, 1),
//     },
//     title: {
//         flexGrow: 1,
//     },
//     wrapper: {
//         margin: theme.spacing(1),
//         position: "relative",
//     },
//     buttonProgress: {
//         color: green[500],
//         position: "absolute",
//         top: "50%",
//         left: "50%",
//         marginTop: -12,
//         marginLeft: -12,
//     },
// },